import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_2 = { class: "flex-grow flex flex-col min-h-0 gap-y-2" }
const _hoisted_3 = { class: "flex-1 overflow-y-auto" }
const _hoisted_4 = {
  key: 2,
  class: "border-gray-lp-1400 w-full flex-grow rounded-xl border"
}
const _hoisted_5 = { class: "text-black-lp-300 w-full border-collapse text-sm" }
const _hoisted_6 = { class: "bg-gray-lp-1000 border-gray-1400 sticky top-0 z-10 border-b font-bold" }
const _hoisted_7 = /*#__PURE__*/_createVNode("th", { class: "p-4 text-left rounded-tl-xl" }, " No. ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("th", { class: "p-4 text-left" }, " No. Manifest Bagging/STI ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("th", { class: "p-4 text-left" }, " No. STT ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("th", { class: "p-4 text-left" }, " Hanging ", -1)
const _hoisted_11 = { class: "p-4 text-left" }
const _hoisted_12 = { class: "p-4 text-left" }
const _hoisted_13 = { class: "p-4 text-center rounded-tr-xl" }
const _hoisted_14 = { class: "bg-white" }
const _hoisted_15 = { class: "px-4 py-1 font-bold" }
const _hoisted_16 = { class: "px-4 py-1.5" }
const _hoisted_17 = { class: "overflow-ellipsis text-left font-bold" }
const _hoisted_18 = { class: "inline-block px-2 rounded-full text-xs font-medium bg-gray-100 text-black-lp-300 leading-5" }
const _hoisted_19 = { class: "px-4 py-1.5" }
const _hoisted_20 = { class: "px-4 py-1.5" }
const _hoisted_21 = { class: "flex flex-col justify-center items-center" }
const _hoisted_22 = {
  key: 0,
  class: "flex justify-center items-center text-black-lp-300 text-10px mt-1"
}
const _hoisted_23 = { class: "overflow-ellipsis leading-4" }
const _hoisted_24 = { class: "px-4 py-1.5" }
const _hoisted_25 = { class: "flex flex-col justify-center items-center text-black-lp-300 text-10px" }
const _hoisted_26 = { class: "inline-block px-2 mb-1 rounded-full text-xs font-medium bg-gray-lp-200 text-black-lp-300 w-max leading-5" }
const _hoisted_27 = { class: "overflow-ellipsis font-bold leading-4" }
const _hoisted_28 = { class: "overflow-ellipsis leading-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterHistory = _resolveComponent("FilterHistory")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "p-3 flex-grow flex flex-col min-h-0",
      rounded: "2xl"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_FilterHistory, { onFilter: _ctx.filter }, null, 8, ["onFilter"]),
          _createVNode("div", _hoisted_3, [
            (_ctx.dataTable.error.empty)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  customHeaderMessage: _ctx.$t('dashboard.hanging.historyEmptyHeader'),
                  customMessage: _ctx.$t('dashboard.hanging.historyEmptyMessage')
                }, null, 8, ["customHeaderMessage", "customMessage"]))
              : (_ctx.dataTable.error.type)
                ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                    key: 1,
                    errorType: _ctx.dataTable.error.type,
                    onTryAgain: _ctx.dataTable.error.onRetry
                  }, null, 8, ["errorType", "onTryAgain"]))
                : (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("table", _hoisted_5, [
                      _createVNode("thead", _hoisted_6, [
                        _createVNode("tr", null, [
                          _hoisted_7,
                          _hoisted_8,
                          _hoisted_9,
                          _hoisted_10,
                          _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('dashboard.hanging.statusPackageExistence')), 1),
                          _createVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('dashboard.hanging.packageLocation')), 1),
                          _createVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('dashboard.hanging.notes')), 1)
                        ])
                      ]),
                      _createVNode("tbody", _hoisted_14, [
                        (_ctx.dataTable.loading)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(10, (row) => {
                              return _createVNode("tr", { key: row }, [
                                (_openBlock(), _createBlock(_Fragment, null, _renderList(7, (col) => {
                                  return _createVNode("td", {
                                    key: col,
                                    class: ["px-4 py-5", {
                        'rounded-bl-xl': col === 1 && row === 10,
                        'rounded-br-xl': col === 7 && row === 10
                      }]
                                  }, [
                                    _createVNode(_component_Skeleton, {
                                      height: "20px",
                                      width: "100%"
                                    })
                                  ], 2)
                                }), 64))
                              ])
                            }), 64))
                          : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataTable.data, (item, index) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: item.manifestNo,
                                class: "border-t border-gray-lp-1400"
                              }, [
                                _createVNode("td", {
                                  class: ["px-4 py-1.5", {
                        'rounded-bl-xl': index === _ctx.dataTable.data.length - 1
                      }]
                                }, _toDisplayString(index + 1 + _ctx.offset), 3),
                                _createVNode("td", _hoisted_15, _toDisplayString(item.manifestNo || "-"), 1),
                                _createVNode("td", _hoisted_16, [
                                  _createVNode("div", _hoisted_17, _toDisplayString(item.sttNo || "-"), 1),
                                  _createVNode("div", _hoisted_18, _toDisplayString(item.aggregator ? "Aggregator" : "Non Aggregator"), 1)
                                ]),
                                _createVNode("td", _hoisted_19, [
                                  _createVNode("div", {
                                    class: "inline-block px-2 py-1 rounded-md text-sm font-medium",
                                    style: _ctx.getHangingStyle(item.hangingDays)
                                  }, _toDisplayString(_ctx.getHangingLabel(item.hangingDays)), 5)
                                ]),
                                _createVNode("td", _hoisted_20, [
                                  _createVNode("div", _hoisted_21, [
                                    _createVNode("div", {
                                      class: "inline-block px-2 rounded-full text-sm font-medium leading-5",
                                      style: _ctx.getStatusStyle(item.existenceStatus)
                                    }, _toDisplayString(_ctx.getStatusLabel(item.existenceStatus)), 5),
                                    (
                            item.existenceStatus !== 'belum_ditemukan' &&
                              item.existenceStatus
                          )
                                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                                          _createVNode("div", _hoisted_23, _toDisplayString(`${item.existenceUsername} - ${_ctx.$moment(
                                item.existenceFindAt
                              ).format("DD MMM YYYY HH:mm")}`), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createVNode("td", _hoisted_24, _toDisplayString(item.existenceLocation || "-"), 1),
                                _createVNode("td", {
                                  class: ["px-4 py-1.5", {
                        'rounded-br-xl': index === _ctx.dataTable.data.length - 1
                      }]
                                }, [
                                  _createVNode("div", _hoisted_25, [
                                    _createVNode("div", _hoisted_26, _toDisplayString(item.status || "-"), 1),
                                    _createVNode("div", _hoisted_27, _toDisplayString(item.username || "-"), 1),
                                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$moment(item.createdAt).format("DD MMM YYYY HH:mm")), 1)
                                  ])
                                ], 2)
                              ]))
                            }), 128))
                      ])
                    ])
                  ]))
          ])
        ])
      ]),
      _: 1
    }),
    (!_ctx.dataTable.loading && _ctx.dataTable.data?.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "px-3",
          paginationPaddingVertical: "py-0",
          rounded: "2xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PaginationV3, {
              pagination: _ctx.dataTable.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataTable.pagination = $event)),
              autoFetch: "",
              renderedData: _ctx.dataTable.data.length,
              onSetPage: _ctx.getHistoryHanging
            }, null, 8, ["pagination", "renderedData", "onSetPage"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}